/**
 * Created by Tiger on 28/02/2022.
 */
import React, {useEffect, useState} from 'react';
import {Form, Modal, Typography} from 'antd';
import i18n from 'i18next';
import {InputItem} from '../../components/inputItem';
import {Footer, useMqttTest} from './util';


export default function CustomMqttConfig(props) {
    const [host, setHost] = useState('');
    const [port, setPort] = useState('');
    const [username, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [clientId, setClientId] = useState('qingping-{mac}');
    const [topicUp, setUpTopic] = useState('qingping/{mac}/up');
    const [topicDown, setDownTopic] = useState('qingping/{mac}/down');
    const [testLoading, testMqtt] = useMqttTest();
    const test = () => testMqtt({
        endpoint: `${ host }:${ port }`, username, password, clientId, topicUp, topicDown,
    });
    const submit = () => props.onOk({
        mqttConfig: {
            host, port: Number(port), username, password, clientId, topicUp, topicDown,
        },
    });


    useEffect(() => {
        if (typeof props?.config === 'object') {
            const {
                host = '',
                port,
                username = '',
                password = '',
                clientId = 'qingping-{mac}',
                topicUp = 'qingping/{mac}/up',
                topicDown = 'qingping/{mac}/down',
            } = props.config;
            setHost(host);
            setPort(port);
            setUserName(username);
            setPassword(password);
            setClientId(clientId);
            setUpTopic(topicUp);
            setDownTopic(topicDown);
        }
    }, [props.config]);
    return (<>
        <Modal
            width={ document.body.clientWidth / 3 }
            title={ i18n.t('edit_mqtt_info_tip') }
            visible={ props.visible }
            maskClosable={ false }
            onCancel={ props.onCancel }
            onOk={ submit }
            footer={ <Footer
                onTest={ test }
                onCancel={ props.onCancel }
                onOk={ submit }
                testLoading={ testLoading }
            /> }
            closable={ true }
        >
            <>
                <Form style={ { marginBottom: 20 } }>
                    <InputItem
                        label={ 'Host' }
                        value={ host }
                        onChange={ event => setHost(event?.target.value.trim()) }/>
                    <InputItem
                        label={ 'Port' }
                        value={ port }
                        onChange={ event => setPort(event?.target.value.trim()) }/>
                    <InputItem
                        label={ 'User Name' }
                        value={ username }
                        onChange={ event => setUserName(event?.target?.value) }/>
                    <InputItem
                        label={ 'Password' }
                        value={ password }
                        onChange={ event => setPassword(event?.target?.value) }/>
                    <InputItem
                        label={ 'Client ID' }
                        value={ clientId }
                        onChange={ event => setClientId(event?.target?.value) }/>
                    <InputItem
                        label={ 'Up Topic' }
                        value={ topicUp }
                        onChange={ event => setUpTopic(event?.target?.value) }/>
                    <InputItem
                        label={ 'Down Topic' }
                        value={ topicDown }
                        onChange={ event => setDownTopic(event?.target?.value) }/>
                </Form>
                <Typography.Text>
                    { i18n.t('mqtt_tips') } <a target={ '_blank' }
                                               href={ '/private/access-instructions/#32-自建-mqtt-服务' }>{ i18n.t('mqtt_tips2') }</a>
                </Typography.Text>
            </>
        </Modal>
    </>);
}
